import request from '../utils/request'

// 我的-拜訪
export function dataScopeUserListApi (data) {
  return request({
    url: '/api/users/dataScopeUserList',
    method: 'get'
  })
}

export function activityLogPageApi (data) {
  return request({
    url: 'api/home/activityLogPage',
    method: 'post',
    data
  })
}

export function dataScopeUserGroupApi () {
  return request({
    url: 'api/users/dataScopeUserGroup',
    method: 'get'
  })
}
